import { render, staticRenderFns } from "./UserCardActionsMenu.vue?vue&type=template&id=5db3ca9e&scoped=true&lang=pug&"
import script from "./UserCardActionsMenu.vue?vue&type=script&lang=js&"
export * from "./UserCardActionsMenu.vue?vue&type=script&lang=js&"
import style0 from "./UserCardActionsMenu.vue?vue&type=style&index=0&id=5db3ca9e&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5db3ca9e",
  null
  
)

export default component.exports